import { infoCards } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">精选推荐</h2>
            <p className="text-sm text-foreground-500 mt-2">深度影评、观影指南与行业观察</p>
          </div>
          <a href="#" className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">
            更多文章 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {infoCards.slice(0, 1).map((card) => (
            <div key={card.id} className="lg:col-span-2 lg:row-span-2 bg-background-100 rounded-xl overflow-hidden group cursor-pointer border border-background-200/60">
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img src={infoCards[0].imageUrl} alt={infoCards[0].title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
              </div>
              <div className="p-5 md:p-6">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-600 text-xs font-medium">{card.category}</span>
                <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-900 mt-3">{card.title}</h3>
                <p className="text-sm text-foreground-500 mt-2 leading-relaxed line-clamp-3">{card.excerpt}</p>
                <div className="flex items-center gap-3 mt-4 text-xs text-foreground-400">
                  <span>{card.date}</span>
                  <span className="text-primary-500 font-medium whitespace-nowrap">阅读全文 →</span>
                </div>
              </div>
            </div>
          ))}
          {infoCards.slice(1).map((card) => (
            <div key={card.id} className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer border border-background-200/60">
              <div className="aspect-[16/10] overflow-hidden bg-background-200">
                <img src={card.imageUrl} alt={card.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" onError={(e) => { (e.target as HTMLElement).parentElement!.style.display = 'none'; }} />
              </div>
              <div className="p-4 md:p-5">
                <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-600 text-xs font-medium">{card.category}</span>
                <h3 className="font-heading text-sm font-bold text-foreground-900 mt-2 line-clamp-2">{card.title}</h3>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2">{card.excerpt}</p>
                <div className="flex items-center gap-3 mt-3 text-xs text-foreground-400">
                  <span>{card.date}</span>
                  <span className="text-primary-500 font-medium whitespace-nowrap">阅读全文 →</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}